import * as actionTypes from './actionTypes';
import * as actions from './index';

export const loadStatistics = (from, to, id) => {
    return dispatch => {
        dispatch(actions.statsVisits(from, to, id));
        dispatch(actions.statsUniqueVisits(from, to, id));
        dispatch(actions.statsTotalViews(from, to, id));
        dispatch(actions.statsViewsPerDay(from, to, id));
        dispatch(actions.statsCSVDownload(from, to, id));
        dispatch(actions.statsMostViewedClips(from, to));
    };
}

export const statsVisits = (from, to, id) => {
    const params = {from: from, to: to };
    if(id) { params.clipid = id }
    
    return dispatch => {
        //dispatch({ type: actionTypes.FTV_LOAD_CSV_USERS_START });
        window.flow.ftvstatsVisits(params).then(res => {
            dispatch({ type: actionTypes.STATISTICS_VISITS_SUCCESS, data: res});
        }).catch(res => {
            // ONLY FOR TESTING
            /*let x = {
                success: true,
                msg: "success",
                data: [{ visits: 148, locations: 'de,fr,en' }]
            }
            dispatch({ type: actionTypes.STATISTICS_VISITS_SUCCESS, data: x});*/
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const statsUniqueVisits = (from, to, id) => {
    const params = {from: from, to: to };
    if(id) { params.clipid = id }
    
    return dispatch => {
        //dispatch({ type: actionTypes.FTV_LOAD_CSV_USERS_START });
        window.flow.ftvstatsUniqueVisits(params).then(res => {
            dispatch({ type: actionTypes.STATISTICS_UNIQUE_VISITS_SUCCESS, data: res});            
        }).catch(res => {
            // ONLY FOR TESTING
            /*let x = {
                success: true,
                msg: "success",
                data: [{ visits: 18, locations: 'de,fr,en' }]
            }
            dispatch({ type: actionTypes.STATISTICS_UNIQUE_VISITS_SUCCESS, data: x});*/
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const statsTotalViews = (from, to, id) => {
    const params = {from: from, to: to };
    if(id) { params.clipid = id }
    
    return dispatch => {
        //dispatch({ type: actionTypes.FTV_LOAD_CSV_USERS_START });
        window.flow.ftvstatsTotalViews(params).then(res => {
            dispatch({ type: actionTypes.STATISTICS_TOTAL_VIEWS_SUCCESS, data: res});
        }).catch(res => {
            // ONLY FOR TESTING
            /*let x = {
                success: true,
                msg: "success",
                data: [{ visits: 745, locations: 'de,fr,en' }]
            }
            dispatch({ type: actionTypes.STATISTICS_TOTAL_VIEWS_SUCCESS, data: x});*/
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const statsViewsPerDay = (from, to, id) => {
    const params = {from: from, to: to };
    if(id) { params.clipid = id }
    
    return dispatch => {
        //dispatch({ type: actionTypes.FTV_LOAD_CSV_USERS_START });
        window.flow.ftvstatsViewsPerDay(params).then(res => {
            dispatch({ type: actionTypes.STATISTICS_VIEWS_PER_DAY_SUCCESS, data: res});
        }).catch(res => {
            // ONLY FOR TESTING
            /*let x = {
                success: true,
                msg: "success",
                data: [
                    { views: 15, locations: 'en,de,fr', adate: '2022-02-21T23:00:00.000Z' },
                    { views: 45, locations: 'en,de,fr', adate: '2022-02-22T23:00:00.000Z' },
                    { views: 10, locations: 'en,de,fr', adate: '2022-02-23T23:00:00.000Z' },
                    { views: 70, locations: 'en,de,fr', adate: '2022-02-24T23:00:00.000Z' },
                    { views: 30, locations: 'en,de,fr', adate: '2022-02-25T23:00:00.000Z' },
                    { views: 21, locations: 'en,de,fr', adate: '2022-02-26T23:00:00.000Z' },
                    { views: 63, locations: 'en,de,fr', adate: '2022-02-27T23:00:00.000Z' },
                ]
            }
            dispatch({ type: actionTypes.STATISTICS_VIEWS_PER_DAY_SUCCESS, data: x});*/
            
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const statsCSVDownload = (from, to, id) => {
    const params = {from: from, to: to };
    if(id) { params.clipid = id }
    
    return dispatch => {
        window.flow.ftvstatsCsvDownload(params).then(res => {
            dispatch({ type: actionTypes.STATISTICS_CSV_DOWNLOAD_SUCCESS, data: res});
        }).catch(res => {
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const statsMostViewedClips = (from, to) => {
    return dispatch => {
        //dispatch({ type: actionTypes.FTV_LOAD_CSV_USERS_START });
        window.flow.ftvstatsMostViewedClips({from: from, to: to }).then(res => {
            dispatch({ type: actionTypes.STATISTICS_MOST_VIEWED_CLIPS_SUCCESS, data: res});
        }).catch(res => {
            // ONLY FOR TESTING
            /*let x = {
                success: true,
                msg: "success",
                data: [
                    {views: 100, clipid: 8138, title: 'Hudson & Rex'},
                    {views: 91, clipid: 8138, title: 'Hudson & Rex'},
                    {views: 86, clipid: 8138, title: 'Hudson & Rex'},
                    {views: 85, clipid: 8138, title: 'Hudson & Rex'},
                    {views: 61, clipid: 8138, title: 'Hudson & Rex'},
                    {views: 32, clipid: 8138, title: 'Hudson & Rex'},
                    {views: 1, clipid: 8138, title: 'Hudson & Rex'},
                ]
            }
            dispatch({ type: actionTypes.STATISTICS_MOST_VIEWED_CLIPS_SUCCESS, data: x});*/
            dispatch(actions.applicationError(res.message));
        });
    };
};

/*
export const ftvCsvFiles = () => {
    return dispatch => {
        dispatch({ type: actionTypes.FTV_LOAD_CSV_FILES_START });
        window.flow.ftvCsvFiles().then(res => {
            dispatch({ type: actionTypes.FTV_LOAD_CSV_FILES_SUCCESS, files: res});
        }).catch(res => {
            dispatch({ type: actionTypes.FTV_LOAD_CSV_FILES_FAIL });
            dispatch(actions.applicationError(res.message));
        });
    };
};
*/
